import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { BRAND } from "../lib/api";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services & Pricing" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,border-color] duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-md border-b border-border shadow-[0_1px_20px_rgba(4,27,36,0.06)]" : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 md:px-8 h-[74px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/logo.png" alt="Bright & Tide Cleaning" className="h-11 w-11 rounded-full object-cover ring-1 ring-border" />
          <span className="font-heading font-extrabold tracking-tight text-ink text-lg leading-none">
            Bright <span className="text-tide">&amp; Tide</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.split(" ")[0].toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors hover:text-tide ${isActive ? "text-tide" : "text-ink/70"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a href={BRAND.phoneHref} data-testid="nav-phone" className="hidden lg:flex items-center gap-2 text-sm font-semibold text-ink hover:text-tide transition-colors">
            <Phone size={16} /> {BRAND.phone}
          </a>
          <Link
            to="/book"
            data-testid="nav-book-btn"
            className="hidden sm:inline-flex items-center rounded-sm bg-ink text-white text-sm font-semibold px-5 py-2.5 transition-transform hover:-translate-y-0.5 hover:bg-brand"
          >
            Get a Free Quote
          </Link>
          <button data-testid="nav-menu-toggle" className="md:hidden text-ink" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-white border-t border-border px-5 py-5 flex flex-col gap-4">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} className="text-base font-medium text-ink">{l.label}</NavLink>
          ))}
          <Link to="/book" className="inline-flex justify-center rounded-sm bg-ink text-white font-semibold px-5 py-3">Get a Free Quote</Link>
          <a href={BRAND.phoneHref} className="text-sm font-semibold text-tide">{BRAND.phone}</a>
        </div>
      )}
    </header>
  );
};
